var editClickHandler = null;
var inputHandler = null;
var saveClickHandler = null;
var runClickHandler = null;
var activeDiscoverySubscription = null;

document.addEventListener("turbo:load", initMobileWebSocialListening);

document.addEventListener("turbo:before-cache", function () {
  var loading = document.querySelector(".mwai-sl-run-btn-loading");
  var label = document.querySelector(".mwai-sl-run-btn-label");
  var runIcon = document.querySelector(".mwai-sl-run-icon");
  var runBtn = document.getElementById("mwai-sl-run-btn");
  var errorEl = document.getElementById("mwai-sl-error");
  var saveBtn = document.getElementById("mwai-sl-save-btn");
  var discoveryCard = document.getElementById("mwai-sl-discovery-card");

  if (loading) loading.style.display = "none";
  if (label) label.style.display = "";
  if (runIcon) runIcon.style.display = "";
  if (runBtn) runBtn.disabled = false;
  if (errorEl) errorEl.style.display = "none";
  if (discoveryCard) discoveryCard.style.display = "none";
  if (saveBtn) {
    saveBtn.disabled = false;
    saveBtn.textContent = "Save website";
  }

  unsubscribeFromDiscovery();
});

function unsubscribeFromDiscovery() {
  if (activeDiscoverySubscription) {
    activeDiscoverySubscription.unsubscribe();
    activeDiscoverySubscription = null;
  }
}

function initMobileWebSocialListening() {
  if (!document.body.classList.contains("mobile-web-ai")) return;

  var card = document.getElementById("mwai-sl-website-card");
  if (!card) return;

  var input = document.getElementById("mwai-sl-website-input");
  var savedEl = document.getElementById("mwai-sl-saved");
  var formEl = document.getElementById("mwai-sl-form");
  var editBtn = document.getElementById("mwai-sl-edit-btn");
  var saveBtn = document.getElementById("mwai-sl-save-btn");
  var errorEl = document.getElementById("mwai-sl-error");
  var errorText = errorEl ? errorEl.querySelector(".mwai-sl-error-text") : null;
  var displayEl = document.getElementById("mwai-sl-website-display");
  var runBtn = document.getElementById("mwai-sl-run-btn");
  var discoveryCard = document.getElementById("mwai-sl-discovery-card");
  var discoveryError = document.getElementById("mwai-sl-discovery-error");
  var discoveryErrorText = discoveryError ? discoveryError.querySelector(".mwai-sl-discovery-error-text") : null;

  var ERROR_VALIDATION = "Please enter a valid website URL";
  var ERROR_SAVE = "Failed to save. Please try again.";

  function isValidUrl(str) {
    return /^https?:\/\/.+\..+/.test(str.trim()) || /^[\w-]+\.[a-z]{2,}/.test(str.trim());
  }

  function showForm() {
    if (savedEl) savedEl.style.display = "none";
    if (editBtn) editBtn.style.display = "none";
    if (formEl) formEl.style.display = "";
    if (input) input.focus();
  }

  function showSaved(url) {
    if (formEl) formEl.style.display = "none";
    if (savedEl) savedEl.style.display = "";
    if (displayEl) displayEl.textContent = url;
    if (editBtn) editBtn.style.display = "";
  }

  function showSaveError(message) {
    if (errorText) errorText.textContent = message || ERROR_SAVE;
    if (errorEl) errorEl.style.display = "";
  }

  function resetErrorText() {
    if (errorText) errorText.textContent = ERROR_VALIDATION;
  }

  function showDiscoveryCard() {
    if (discoveryCard) discoveryCard.style.display = "";
    if (discoveryError) discoveryError.style.display = "none";
    if (editBtn) editBtn.style.display = "none";
    if (runBtn) runBtn.disabled = true;

    var spinner = discoveryCard ? discoveryCard.querySelector(".mwai-sl-discovery-spinner") : null;
    var title = discoveryCard ? discoveryCard.querySelector(".mwai-sl-discovery-title") : null;
    var subtitle = discoveryCard ? discoveryCard.querySelector(".mwai-sl-discovery-subtitle") : null;
    if (spinner) spinner.style.display = "";
    if (title) title.textContent = "Discovering your brand...";
    if (subtitle) subtitle.textContent = "This may take a few minutes. Come back later to run social listening.";
  }

  function hideDiscoveryCard() {
    if (discoveryCard) discoveryCard.style.display = "none";
    if (editBtn) editBtn.style.display = "";
    if (runBtn) runBtn.disabled = false;
  }

  function showDiscoveryComplete() {
    var spinner = discoveryCard ? discoveryCard.querySelector(".mwai-sl-discovery-spinner") : null;
    var title = discoveryCard ? discoveryCard.querySelector(".mwai-sl-discovery-title") : null;
    var subtitle = discoveryCard ? discoveryCard.querySelector(".mwai-sl-discovery-subtitle") : null;
    if (spinner) spinner.style.display = "none";
    if (title) title.textContent = "Brand discovery complete!";
    if (subtitle) subtitle.textContent = "You can now run social listening.";
    if (editBtn) editBtn.style.display = "";
    if (runBtn) runBtn.disabled = false;

    setTimeout(function () { hideDiscoveryCard(); }, 3000);
  }

  function showDiscoveryError(message) {
    var spinner = discoveryCard ? discoveryCard.querySelector(".mwai-sl-discovery-spinner") : null;
    if (spinner) spinner.style.display = "none";
    if (discoveryErrorText) discoveryErrorText.textContent = message || "Brand discovery failed. Please try again.";
    if (discoveryError) discoveryError.style.display = "";
    if (editBtn) editBtn.style.display = "";
  }

  function subscribeToDiscoveryJob(jobId) {
    unsubscribeFromDiscovery();

    if (!window.App || !window.App.cable) return;

    activeDiscoverySubscription = App.cable.subscriptions.create(
      { channel: "BrandDiscoveryJobChannel", id: jobId },
      {
        received: function (data) {
          var result = data.result || data;
          if (!result.completed) return;

          if (result.success) {
            showDiscoveryComplete();
            if (saveBtn) saveBtn.setAttribute("data-has-brand", "true");
          } else {
            showDiscoveryError(result.error);
          }
          unsubscribeFromDiscovery();
        },
        rejected: function () {
          showDiscoveryError("Connection lost. Please refresh the page.");
        }
      }
    );
  }

  // If brand discovery is already in progress on page load, subscribe to it
  if (discoveryCard && discoveryCard.style.display !== "none") {
    var existingJobId = discoveryCard.getAttribute("data-job-id");
    if (existingJobId) {
      subscribeToDiscoveryJob(parseInt(existingJobId, 10));
    }
  }

  if (editBtn) {
    if (editClickHandler) editBtn.removeEventListener("click", editClickHandler);
    editClickHandler = showForm;
    editBtn.addEventListener("click", editClickHandler);
  }

  if (input) {
    if (inputHandler) input.removeEventListener("input", inputHandler);
    inputHandler = function () {
      resetErrorText();
      var val = input.value.trim();
      if (val && !isValidUrl(val)) {
        if (errorEl) errorEl.style.display = "";
        if (saveBtn) saveBtn.disabled = true;
      } else {
        if (errorEl) errorEl.style.display = "none";
        if (saveBtn) saveBtn.disabled = !val;
      }
    };
    input.addEventListener("input", inputHandler);

    if (saveBtn && input.value.trim() === "") {
      saveBtn.disabled = true;
    }
  }

  if (saveBtn) {
    if (saveClickHandler) saveBtn.removeEventListener("click", saveClickHandler);
    saveClickHandler = function () {
      var url = input ? input.value.trim() : "";
      if (!url || !isValidUrl(url)) return;

      if (!/^https?:\/\//.test(url)) {
        url = "https://" + url;
        if (input) input.value = url;
      }

      saveBtn.disabled = true;
      saveBtn.textContent = "Saving...";

      var csrfToken = document.querySelector('meta[name="csrf-token"]');
      var token = csrfToken ? csrfToken.getAttribute("content") : "";
      var hasBrand = saveBtn.getAttribute("data-has-brand") === "true";

      if (hasBrand) {
        saveWebsiteViaUpdate(url, token);
      } else {
        saveWebsiteViaBrandDiscovery(url, token);
      }
    };
    saveBtn.addEventListener("click", saveClickHandler);
  }

  function saveWebsiteViaUpdate(url, token) {
    fetch(saveBtn.getAttribute("data-url"), {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: JSON.stringify({ brand: { website: url }, source: "mobile_social_listening" })
    })
    .then(function (response) {
      if (response.ok) {
        showSaved(url);
        if (runBtn) runBtn.disabled = false;
      } else {
        showSaveError();
      }
    })
    .catch(function () {
      showSaveError();
    })
    .finally(function () {
      saveBtn.disabled = false;
      saveBtn.textContent = "Save website";
    });
  }

  function saveWebsiteViaBrandDiscovery(url, token) {
    fetch(saveBtn.getAttribute("data-analyze-url"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: JSON.stringify({ website: url, source: 'mobile_social_listening' })
    })
    .then(function (response) {
      return response.json().then(function (data) {
        return { ok: response.ok, status: response.status, data: data };
      });
    })
    .then(function (result) {
      if (result.ok && result.data.job_id) {
        showSaved(url);
        showDiscoveryCard();
        subscribeToDiscoveryJob(result.data.job_id);
      } else if (result.status === 409) {
        showSaved(url);
        showDiscoveryCard();
        if (result.data.job_id) {
          subscribeToDiscoveryJob(result.data.job_id);
        }
      } else if (result.status === 402) {
        return fallbackToDirectSave(url, token);
      } else {
        showSaveError(result.data.error || null);
      }
    })
    .catch(function () {
      showSaveError();
    })
    .finally(function () {
      saveBtn.disabled = false;
      saveBtn.textContent = "Save website";
    });
  }

  function fallbackToDirectSave(url, token) {
    return fetch(saveBtn.getAttribute("data-url"), {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: JSON.stringify({ brand: { website: url }, source: "mobile_social_listening" })
    })
    .then(function (response) {
      if (response.ok) {
        showSaved(url);
        saveBtn.setAttribute("data-has-brand", "true");
        if (runBtn) runBtn.disabled = false;
      } else {
        showSaveError();
      }
    })
    .catch(function () {
      showSaveError();
    })
    .finally(function () {
      saveBtn.disabled = false;
      saveBtn.textContent = "Save website";
    });
  }

  if (runBtn) {
    var label = runBtn.querySelector(".mwai-sl-run-btn-label");
    var loading = runBtn.querySelector(".mwai-sl-run-btn-loading");
    var runIcon = runBtn.querySelector(".mwai-sl-run-icon");

    if (runClickHandler) runBtn.removeEventListener("click", runClickHandler);
    runClickHandler = function () {
      if (runBtn.disabled) return;
      if (label) label.style.display = "none";
      if (runIcon) runIcon.style.display = "none";
      if (loading) loading.style.display = "";
    };
    runBtn.addEventListener("click", runClickHandler);
  }
}
